(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userProfileService', userProfileService);

    /* @ngInject */
    function userProfileService(coreService) {
        var service = {
            getUserProfile: getUserProfile,
            getLocations: getLocations,
            getDepartmentRoles: getDepartmentRoles,
            getJobTitles: getJobTitles,
            updateProfileInformation: updateProfileInformation
        };

        activate();

        return service;

        function activate() {
        }

        function getUserProfile(userId)
        {
            var url = 'user/currentprofile';
            return coreService.httpAccountsPost(url);
        }

        function getLocations() {
            return coreService.httpAccountsGet('/corporateHierarchy');
        }

        function getDepartmentRoles() {
            return coreService.httpAccountsGet('/departmentRole');           
        }

        function getJobTitles() {
            return coreService.httpAccountsGet('/jobTitle');
        }

        function updateProfileInformation(profile)
        {
            return coreService.httpAccountsPost('user/profile', profile);
        }
    }
})();
